import { render, staticRenderFns } from "./ChooseProfile.vue?vue&type=template&id=6c24662c&scoped=true&"
import script from "./ChooseProfile.vue?vue&type=script&lang=js&"
export * from "./ChooseProfile.vue?vue&type=script&lang=js&"
import style0 from "./ChooseProfile.vue?vue&type=style&index=0&id=6c24662c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c24662c",
  null
  
)

export default component.exports